export default "__VITE_ASSET__C24BCn____"